import { useState } from "react";
import "./App.css";
import Counter from './components/Counter';

const App = () => {

  const [show, setShow] = useState(false);

  return (
    <div className="container">
      <h1>Counter App</h1>

      <button onClick={() => setShow(!show)}>
        {show ? "Hide Counter" : "Show Counter"}
      </button>

      {show && (
        <Counter />
      )}
    </div>
  );
}

export default App;